module.exports = __webpack_public_path__ + "img/logo-no-type.dbea40fe.svg";